import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Flame } from "lucide-react";
import { MarketplaceGate } from "@/components/marketplace/gate";
import { MarketplaceServiceCard } from "@/components/marketplace/service-card";
import { isFeatured } from "@/lib/marketplace/promotions";
import { fetchMarketplaceServices } from "@/lib/marketplace/queries";
import { buildPageMetadata } from "@/lib/seo";
import { useT } from "@/i18n";

export const Route = createFileRoute("/marketplace/hot")({
  head: () =>
    buildPageMetadata({
      path: "/marketplace/hot",
      title: "HOT services right now | BeHot.Now Marketplace",
      description:
        "The hottest creator services on BeHot.Now, ranked by real demand: orders, ratings, favourites and Heat from the live boards.",
      keywords: ["hot creator services", "trending influencers", "top rated UGC"],
      breadcrumbs: [
        { name: "Home", path: "/" },
        { name: "Marketplace", path: "/marketplace" },
        { name: "HOT", path: "/marketplace/hot" },
      ],
    }),
  component: HotPage,
});

function HotPage() {
  const { t } = useT();
  const { data } = useQuery({
    queryKey: ["mp-hot"],
    queryFn: () => fetchMarketplaceServices({ sort: "hot", limit: 48 }),
  });

  return (
    <MarketplaceGate>
      <div className="mx-auto max-w-6xl px-4 py-8">
        <h1 className="flex items-center gap-2 font-display text-3xl font-bold">
          <Flame className="size-7 text-primary" /> {t("mp.hot.title")}
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          {t("mp.hot.subtitle")}
        </p>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {(data ?? []).map((s) => (
            <MarketplaceServiceCard key={s.id} service={s} promoted={isFeatured(s.featured_until)} />
          ))}
        </div>
        {!data?.length && (
          <p className="mt-10 text-center text-sm text-muted-foreground">{t("mp.hot.empty")}</p>
        )}
      </div>
    </MarketplaceGate>
  );
}
